import { NgModule } from 'angular-ts-decorators';

import { HeroCustomizerV2Component } from './hero-customizer-v2.component';

import { CustomizerApiService } from './customizer-api.service';

import { HeroCustomizerV2FilteringModule } from './filtering/module';
import { HeroCustomizerV2ImageGalleryModule } from './image-gallery/module';
import { moduleName } from './constants';

@NgModule({
  declarations: [HeroCustomizerV2Component],
  id: moduleName,
  imports: [
    HeroCustomizerV2FilteringModule,
    HeroCustomizerV2ImageGalleryModule,
  ],
  providers: [CustomizerApiService],
})
export class HeroCustomizerV2Module {
}
